import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAboutImages } from '../../services/about_Images';

export const getAbout = createAsyncThunk(
    'about',
    async (data, { getState, rejectWithValue }) => {
      try {
        const token = getState().auth.token;
        const response = await getAboutImages(data, token.token);
        
        return { data: response.data.list, total: response.data.total };
      } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Failed to fetch users');
      }
    }
  );
  